(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  document.addEventListener('click', function(e) {
      if (e.target.matches('.mobile-nav-close') || e.target.closest('.mobile-nav-close')) {
          const headerIcon = document.querySelector('summary[aria-controls="menu-drawer"]');
          if (headerIcon) {
              headerIcon.click();
          }
      }
  });
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
let dropdownItems = document.querySelector(".header__submenu");

items.forEach(item => {
  let hoverTimeout;
  
  // Mouse enter on the main menu item
  item.addEventListener("mouseenter", () => {
    // Clear any existing timeout
    clearTimeout(hoverTimeout);
    
    // Close all other dropdowns first
    items.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });
    
    // Open current dropdown
    item.setAttribute("open", "");
  });
  
  // Mouse leave on the main menu item
  item.addEventListener("mouseleave", () => {
    // Add a delay before closing to allow mouse to move to submenu
    hoverTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 200); // 200ms delay - adjust as needed
  });
  
  // Find the submenu within this item
  let ulElement = item.querySelector("ul");
  if (ulElement !== null) {
    // Mouse enter on submenu - keep dropdown open
    ulElement.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);
      item.setAttribute("open", "");
    });
    
    // Mouse leave on submenu - close dropdown
    ulElement.addEventListener("mouseleave", () => {
      hoverTimeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 100); // Shorter delay when leaving submenu
    });
  }
  
  // Keep focus/blur events for accessibility
  item.addEventListener("focus", () => {
    item.setAttribute("open", "");
  });
  
  item.addEventListener("blur", () => {
    // Add small delay for blur as well
    setTimeout(() => {
      item.removeAttribute("open");
    }, 100);
  });
});

// Close all dropdowns when mouse leaves the entire menu area
if (dropdownItems !== null) {
  dropdownItems.addEventListener("mouseleave", () => {
    items.forEach(item => {
      item.removeAttribute("open");
    });
  });
}

// Optional: Close dropdowns when clicking outside
document.addEventListener("click", (e) => {
  if (!e.target.closest(".header__inline-menu")) {
    items.forEach(item => {
      item.removeAttribute("open");
    });
  }
});

// Optional: Close dropdowns on Escape key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    items.forEach(item => {
      item.removeAttribute("open");
    });
  }
}); 

  } catch(e) { console.error(e); }
})();
})();
